import React from 'react';
import './Offer.scss';

export function Offer() {
  return (
    <article className="offer-article">
      <h3>
        wynagrodzenie
        <br />
        radcy prawnego
      </h3>
      <div className="main-content-text">
        <p>
          Świadczone przez moją kancelarię kompleksowe usługi prawne wyróżniają
          się <b>wysoką jakością</b> oraz{' '}
          <b>przystępnymi i&nbsp;rozsądnymi warunkami cenowymi</b>.
        </p>
        <p>
          Wysokość honorarium radcowskiego zależy od&nbsp;
          <b>charakteru sprawy</b>, <b>wartości przedmiotu sporu</b>,{' '}
          <b>stopnia jej skomplikowania</b> oraz&nbsp;<b>nakładu pracy</b>.
        </p>
        <p>
          Jednocześnie gwarantuję indywidualne i&nbsp;elastyczne podejście
          do&nbsp; każdego klienta, co&nbsp;pozwala na&nbsp;ustalenie warunków
          umowy odpowiadających jego oczekiwaniom w&nbsp;zakresie wyceny usługi.
          Ważne jest, aby warunki te&nbsp;zostały uzgodnione na&nbsp;początku
          współpracy, zapewniając pełną <b>przejrzystość wynagrodzenia</b>.
          Dzięki temu klient może podjąć świadomą decyzję o&nbsp;skorzystaniu
          z&nbsp; pomocy prawnika oraz odpowiednio{' '}
          <b>zaplanować swoje wydatki</b>.
        </p>
      </div>
    </article>
  );
}
